import {useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {getLease, getLeaseAssets, getLeaseContracts} from "../../../../api/asset/AssetLeaseService";
import {AssetLeaseInfo} from "./subPages/AssetLeaseInfo";
import {DetailHeroSummaryProvider, DetailTabBar} from "../../../../components/detailLayout";
import "../../../../components/detailLayout/detailListLayout.css";
import {CommonHistoryList} from "../../../settings/history/subPages/CommonHistoryList";
import {skeleton} from "../../../../redux/slice/apiSlice";
import {useDispatch, useSelector} from "react-redux";
function AssetLeaseTab(){
    const { id } = useParams();
    const status = useSelector(state => state.api.status);

    const [tab, setTab] = useState([
        {clicked: true, name: "기본정보"},
        {clicked: false, name: "이력관리"},
    ]);

    const [lease, setLease] = useState(null);
    const [assets, setAssets] = useState([]);
    const [contracts, setContracts] = useState([]);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    async function getData() {
        Promise.all([
            getLease(id),
            getLeaseContracts(id),
            getLeaseAssets(id),
        ]).then(([lease, contract, asset]) => {
            if(lease.status === 201) {
                if (lease.data.errorCode = 'AUTHORITY') {
                    alert(lease.data.reason)
                    navigate(-1)
                }
            }

            setLease(lease.data);
            setAssets(
                asset.data
                     .filter(item => item.assets) // assets가 존재하는 경우만 필터링
                     .map(item => item.assets));
            setContracts(
                contract.data
                        .filter(item => item.contracts)
                        .map(item => item.contracts));

        }).finally(
            dispatch(skeleton(false))
        )

        dispatch(skeleton(false));
    }

    useEffect(() => {
        if (!id) return;
        setLease(null);
        setAssets([]);
        setContracts([]);
        getData();
    }, [id, status])

    if(lease) {
        return (
                <div className="common-container container-height detail-list-layout asset-detail-list-layout border-l-gray">
                    <DetailHeroSummaryProvider>
                        <DetailTabBar tabs={tab} setTabs={setTab} />

                    {tab[0].clicked && (
                        <AssetLeaseInfo
                            key={id}
                            lease={lease}
                            setLease={setLease}
                            assets={assets}
                            setAssets={setAssets}
                            contracts={contracts}
                            setContracts={setContracts}
                        />
                    )}
                    {tab[1].clicked && <CommonHistoryList id={id} tableName={"자산리스관리"} />}
                    </DetailHeroSummaryProvider>
                </div>
        );
    }
}

export {AssetLeaseTab}